import type * as Types from '../../../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateCompanyMediaplanTypeMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  typeObject: Types.AccountsCompanyMediaplanTypeInput;
}>;


export type UpdateCompanyMediaplanTypeMutationPage = { readonly __typename?: 'RootMutationType', readonly updateCompanyMediaplanType: boolean };


export const UpdateCompanyMediaplanTypeDocument = gql`
    mutation UpdateCompanyMediaplanType($id: ID!, $typeObject: AccountsCompanyMediaplanTypeInput!) {
  updateCompanyMediaplanType(id: $id, typeObject: $typeObject)
}
    `;
export type UpdateCompanyMediaplanTypeMutationFn = Apollo.MutationFunction<UpdateCompanyMediaplanTypeMutationPage, UpdateCompanyMediaplanTypeMutationVariables>;

/**
 * __useUpdateCompanyMediaplanTypeMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyMediaplanTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyMediaplanTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyMediaplanTypeMutation, { data, loading, error }] = useUpdateCompanyMediaplanTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      typeObject: // value for 'typeObject'
 *   },
 * });
 */
export function useUpdateCompanyMediaplanTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyMediaplanTypeMutationPage, UpdateCompanyMediaplanTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyMediaplanTypeMutationPage, UpdateCompanyMediaplanTypeMutationVariables>(UpdateCompanyMediaplanTypeDocument, options);
      }
export type UpdateCompanyMediaplanTypeMutationHookResult = ReturnType<typeof useUpdateCompanyMediaplanTypeMutation>;
export type UpdateCompanyMediaplanTypeMutationResult = Apollo.MutationResult<UpdateCompanyMediaplanTypeMutationPage>;
export type UpdateCompanyMediaplanTypeMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyMediaplanTypeMutationPage, UpdateCompanyMediaplanTypeMutationVariables>;